import {getInstitutionId} from '../app/constants/constant';
const institution = getInstitutionId('qa');
export const environment = {
    production: false,
    enableClickEvents: true,
    isMockEnabled: false, // You have to switch this, when your real back-end is done
    baseUrl: '',
    apiUrl: 'https://qab2bapi.creditsnap.com/csb2b',
    apiUrlWithoutToken: 'https://qab2bapi.creditsnap.com/csb2b',
    socketBaseUrl: 'wss://tjmtwxc53f.execute-api.us-east-1.amazonaws.com/qa',
    depositApiUrl: 'https://qab2bapi.creditsnap.com/csb2b/deposit/account',
    depositApiUrlWithoutToken: 'https://qab2bapi.creditsnap.com/csb2b/deposit/account',
    websiteUrl: '',
    channel: 'web',
    provisionApiUrl : 'https://e6f8tpbouc.execute-api.us-east-1.amazonaws.com/cs/provisions-qa',
    authorizeEndpoint: 'https://test.authorize.net/payment/payment',
    institutionId: institution.institutionId,
    cxUrl: institution.cxUrl,
    ALGOLIA_API_KEY: 'e5da8fc6cc242701e8b13503ee3a4dda',
    ALGOLIA_APPLICATION_ID: '7MV7A9XWSE',
    s3Url: 'https://creditsnap-public-uat.s3.amazonaws.com/',
    s3ConfigUrl: 'https://creditsnap-content-uat.s3.us-east-1.amazonaws.com/qa/',
    client: {
        clientAppStatusURL: '',
        secretKey: '',
    },
    auth: {
        basic: 'Basic Y3NfdHJ1c3RlZF9jbGllbnQ6eHlzckdlN0dvdzJkZWZn',
        scope: 'read write trust',
        grantType: 'password',
        interceptorSkipHeader: 'X-Skip-Interceptor'
    },
    debug: false,
    type: 'TEST',
    env: 'qa',
    socureSDKKey: '',
    logRocket: {
        appId: 'uhoxqf/deposit-sandbox', // LogRocket app id (org/app)
    },
};
